import Vue from "vue";
import { ActionContext, ActionTree } from "vuex";
import { CLIENTES} from "./types";
import { RootState } from "@/store/modules/general/types";
import { AxiosResponse } from "axios";

type ClientesContext = ActionContext<CLIENTES, RootState>;
type ClientesActionTree = ActionTree<CLIENTES, RootState>;

export const actions: ClientesActionTree = {
  async listarClientes(context: ClientesContext, payload: any): Promise<any> {
    try {
      const response: AxiosResponse = await Vue.axios({
        method: "GET",
        url: "/Clientes/ListaClientes",
        params: payload,
      });
      return response.data;
    } catch (error) {
      //Vacio, porque puede venir cualquier cosa.. :D
    }
  },
  async obtenerCliente(context: ClientesContext, payload: any): Promise<any> {
    try {
      const response: AxiosResponse = await Vue.axios({
        method: "GET",
        url: "/Clientes/obtenerCliente",
        params: payload,
      });
      return response.data;
    } catch (error) {
      //Vacio, porque puede venir cualquier cosa.. :D
    }
  },
};
